import { useCountry } from "../context/CountryContext";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

// Compact global country selector for the header: flag + short label only.
// UI-only — the country codes still drive the existing filtering (UK = GB).
const OPTIONS = [
  { code: "GB", flag: "🇬🇧", label: "UK" },
  { code: "AU", flag: "🇦🇺", label: "AUS" },
  { code: "NZ", flag: "🇳🇿", label: "NZ" },
  { code: "US", flag: "🇺🇸", label: "USA" },
];

export function CountrySelector({ className = "" }) {
  const { country, setCountry } = useCountry();
  return (
    <Select value={country} onValueChange={setCountry}>
      <SelectTrigger
        data-testid="global-country-select"
        className={`h-9 w-auto gap-1 rounded-full border-white/10 bg-[#0a0a0a] px-3 text-xs font-semibold text-white ${className}`}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="min-w-[7rem] rounded-2xl border-white/10 bg-[#121212] text-white">
        {OPTIONS.map((c) => (
          <SelectItem
            key={c.code}
            value={c.code}
            data-testid={`global-country-${c.code}`}
            className="rounded-lg text-white focus:bg-white/10 focus:text-white data-[state=checked]:text-[#ff2a00]"
          >
            <span className="mr-1">{c.flag}</span>
            {c.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
